import { Fragment } from "react";
import Link from "next/link";
import styles from "./Breadcrumbs.module.scss";

export default function Breadcrumbs({ breadcrumbs }) {
  const breadcrumbLinks = breadcrumbs.map((breadcrumb, index) => {
    return (
      <Fragment key={breadcrumb.link}>
        <Link href={`${breadcrumb.link}`} className={`${styles.breadcrumb}`}>
          <span className={`${styles.name}`}>{breadcrumb.name}</span>
          {index !== breadcrumbs.length - 1 && (
            <span className={`${styles.connector}`}>&nbsp;&gt;&nbsp;</span>
          )}
        </Link>
      </Fragment>
    );
  });
  return <div className={`${styles.container}`}>{breadcrumbLinks}</div>;
}
